module.exports = __webpack_public_path__ + "img/e13656f.png";